import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Close, CheckCircle, ErrorOutline } from '@material-ui/icons';

import ProductItem from './product-item/product-item';
import IconCopy from '../../../assets/icons/Copy';
// import Trash from '../../../assets/icons/Trash';
import { DiscountInput } from '../../../components/discount-input/DiscountInput';
import { currencyFormatter } from '../../../utils';
import { useNotificationProvider } from '../../../components/notifications/NotificationProvider';
// import { useCartStandaloneProvider } from '../cart-standalone-side-bar/cart-standalone-provider/cart-standalone-provider';
// import useStandaloneCartActions from '../../../hooks/useStandaloneCartActions';

import './standalone-cart-details-side-bar.scss';

const StandaloneCartDetailsSideBar = ({ sidebarAnimation, onCloseStandaloneCartDetailsSidebar, selectedItem, paginationRefetch }) => {
      const shops = useSelector((state) => state.shops);
      const { showToast } = useNotificationProvider();
      // const { setIsStandaloneCartDetailsSideBarShown } = useCartStandaloneProvider();

      // const { onDeleteStandaloneCart } = useStandaloneCartActions();

      const isConverted = selectedItem?.totalOrderAmount > 0;
      const productsCount = selectedItem?.products?.length || 0;

      const totalSum = useMemo(() => (
            (selectedItem?.products ?? []).reduce((sum, product) => sum + product.quantity * product.price, 0)
      ), [JSON.stringify(selectedItem?.products ?? [])]);

      const activeShopId = shops.activeShopId;

      const isStandaloneCartEmpty = !selectedItem?.products || selectedItem?.products.length === 0;

      const copyToClipboard = () => {
            if (!isStandaloneCartEmpty) {
                  showToast({
                        description: 'Link copied to clipboard',
                        type: 'info',
                  });
                  navigator.clipboard.writeText(selectedItem?.cartRecoveryUrl);
            }
      };

      // const handleDelete = async () => {
      //       const result = await onDeleteStandaloneCart(selectedItem.id);
      //
      //       if (result.success) {
      //             showToast({
      //                   description: 'Cart deleted successfully',
      //                   type: 'success',
      //             });
      //
      //             setIsStandaloneCartDetailsSideBarShown(false);
      //
      //             if (paginationRefetch) {
      //                   paginationRefetch();
      //             }
      //       } else {
      //             showToast({
      //                   description: 'Failed to delete cart',
      //                   type: 'error',
      //             });
      //             console.error('Failed to delete cart:', result.error);
      //       }
      // };

      return (
            <div className={`standalone-cart-details-sidebar-container ${sidebarAnimation}`}>
                  <div className="standalone-cart-details-sidebar-header">
                        <div className="title-container">
                              <p className="standalone-cart-details-title">Standalone Cart Details</p>
                              <button onClick={onCloseStandaloneCartDetailsSidebar}>
                                    <Close />
                              </button>
                        </div>
                  </div>

                  <div className={`copy-link-action ${isStandaloneCartEmpty && 'copy-link-action-disabled'}`}
                       onClick={copyToClipboard}>
                        <IconCopy />
                        <p>Copy Standalone Cart</p>
                  </div>

                  {/*<div className="delete-sa-cart-action" onClick={handleDelete}>*/}
                  {/*      <div className="clickable">*/}
                  {/*            <Trash width={20} height={20} fill="#be1919" />*/}
                  {/*            <p>Delete Standalone Cart</p>*/}
                  {/*      </div>*/}
                  {/*</div>*/}

                  <div className="profile-info">
                        <div className="profile-details">
                              <p className="profile-name">{selectedItem.customerFullName || 'Unknown customer'}</p>
                              <p className="profile-email">{selectedItem.customerEmail || 'No email provided'}</p>
                              <p className="profile-date">
                                    Created:{' '}
                                    {new Date(selectedItem.createdAt.seconds * 1000).toLocaleDateString()}
                              </p>
                        </div>

                        <div className={`conversion-badge ${isConverted ? 'converted' : 'not-converted'}`}>
                              {isConverted ? (
                                    <>
                                          <CheckCircle className="icon" />
                                          <span>Converted</span>
                                    </>
                              ) : (
                                    <>
                                          <ErrorOutline className="icon" />
                                          <span>Not Converted</span>
                                    </>
                              )}
                        </div>
                  </div>

                  <div className="products-wrapper">
                        <div className="products-counter">
                              {productsCount} {productsCount === 1 ? 'product' : 'products'} in cart
                        </div>

                        {
                              (selectedItem?.products ?? []).map((product) => (
                                    <ProductItem product={product} key={product.productId} />
                              ))
                        }
                  </div>

                  <>
                        {selectedItem?.cartDiscount && (
                              <DiscountInput
                                    isViewMode
                                    cartId={selectedItem.cartId}
                                    shopId={activeShopId}
                                    cartDiscount={selectedItem.cartDiscount}
                              />
                        )
                        }

                        <div className="tab-total">
                              <p>Total: </p>
                              <p>{currencyFormatter(totalSum, selectedItem.cartCurrencyCode)}</p>
                        </div>
                  </>
            </div>
      )
}

export default StandaloneCartDetailsSideBar;
